import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar.jsx";
import Blogs from "./Pages/Blogs/Blogs.jsx";
import DetailsBlog from "./Pages/DetailsBlog/DetailsBlog.jsx";

function App() {
  return (
    <Router>
    <Navbar />
    <Routes>
        <Route path="/" element={<Blogs />} />
        <Route path="/blogs/:blogId" element={<DetailsBlog />} />
    </Routes>
</Router>
  );
}

export default App;
